<p>base-credentials-form works!</p>
